import { LoadingTypes } from '../constants/loadingConstants';

const initialState = {
    loadingSources: [],
    error: null,
    errorshow: null,
    connectionStatus: 'offline',
    showBugReport: false,
};

const loadingDone = (state, key) => {
    let result = [...state.loadingSources];
    let finish = false;

    result = result.filter(k => {
        if (finish) {
            return true;
        }

        if (k === key) {
            finish = true;
            return false;
        }

        return true;
    })

    return result;
}


export const loadingReducer = (state = initialState, action) => {
    switch (action.type) {
        case LoadingTypes.LOADING_START:
            return {
                ...state,
                loadingSources: [...state.loadingSources, action.key]
            };

        case LoadingTypes.LOADING_END:
            return {
                ...state,
                loadingSources: loadingDone(state, action.key)
            };

        case LoadingTypes.HANDLE_ERROR:
            return {
                ...state,
                error: action.error
            };

        case LoadingTypes.SHOW_ERROR:
            return {
                ...state,
                errorshow: action.error
            };

        case LoadingTypes.SET_CONNECTION_STATUS:
            console.log('Setting connection to ', action.status);
            return {
                ...state,
                connectionStatus: action.status
            };

        case LoadingTypes.SET_BUGREPORT_STATUS:
            return {
                ...state,
                showBugReport: action.show
            };
        
        default:
            return state;
    }
};